// extracted by mini-css-extract-plugin
export var ayContactItemIcon = "styles-module--ay-contact-item-icon--3429e";
export var ayContactItemTitle = "styles-module--ay-contact-item-title--45ede";
export var ayContactWrapper = "styles-module--ay-contact-wrapper--19eb8";
export var contentWrapper = "styles-module--content-wrapper--9775e";
export var firstGlow = "styles-module--first-glow--4566a";
export var mainContent = "styles-module--main-content--8eb6b";
export var secondGlow = "styles-module--second-glow--4da94";
export var title = "styles-module--title--8f00f";
export var wrapper = "styles-module--wrapper--40bb3";